import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";

import invoiceStore from "../../stores/invoiceStore";
import { buildApiUrl } from "../../config/api";

import "./index.css";

const InvoiceDetails = () => {
  const { guid } = useParams();
  const navigate = useNavigate();
  const {
    getSpecificInvoice,
    updateInvoice,
    specificInvoice,
    isLoadingSpecificInvoice,
  } = invoiceStore;

  useEffect(() => {
    getSpecificInvoice({
      guid: guid,
    });
  }, [guid, getSpecificInvoice]);

  const onApproveInvoice = async () => {
    const payload = {
      accepted: true,
    };
    await updateInvoice({
      guid: guid,
      payload: payload,
      onSuccess: () => navigate(`/payments/${guid}`),
    });
  };

  return isLoadingSpecificInvoice ? (
    <>Loading...</>
  ) : (
    <div className="invoice-details-page pb-5">
      <p>
        <strong>Customer Name:</strong> {specificInvoice?.job?.client?.name}
      </p>
      <h1>Invoice Details</h1>
      <p>
        <strong>Job:</strong> {specificInvoice?.job?.job_number}
      </p>
      <p>
        <strong>Amount Due:</strong> {specificInvoice.amount_due}{" "}
        <span>(50% Deposit)</span>
      </p>
      <p>
        <strong>Date:</strong> {specificInvoice.due_date}
      </p>
      <p>
        <strong>Status:</strong> {specificInvoice.status}
      </p>
      <div className="mt-4 mb-4 d-flex gap-2">
        {!specificInvoice?.job?.estimate_accepted && (
          <button className="blueBtn" onClick={() => onApproveInvoice()}>
            Approve
          </button>
        )}
        {specificInvoice?.job?.estimate_accepted && (
          <button
            className="blueBtn"
            onClick={() => navigate(`/payments/${guid}`)}
          >
            Go To Payments
          </button>
        )}
        <a
          className="blueBtn public-pdf-link"
          href={buildApiUrl(`generate-invoice-by-guid/${guid}/`)}
          target="_blank"
          rel="noopener noreferrer"
        >
          View PDF
        </a>
      </div>
    </div>
  );
};

export default observer(InvoiceDetails);
